import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import FirstSectionStore from '@src/pages/main/sections/first-section/store';
// import { useRef } from 'react';
import cx from 'classnames';
import Link from '@src/components/link';
import NewsSwiper from '@src/business-components/news-swiper';
import locales from './locales';

import SilentVideo from '@src/components/silent-video';

const styles = require('./index.less');

const FirstSection = ({ store }) => {
  store.use();

  const AppointmentBtn = () => {
    if (store.downLoadBtnState) {
      return null;
      // return (
      //   <Link
      //     className={cx(styles.btn, styles.downloadBtn)}
      //     data-name="前往下载"
      //     onClick={() => {
      //       store.onClickAppointment();
      //     }}
      //   >
      //     {/* Download */}
      //     {locales.downloadBtn}
      //   </Link>
      // );
    } else {
      return (
        <Link
          className={cx(styles.btn, styles.btn_Appointment)}
          data-name="官网预约"
          onClick={() => {
            store.onClickAppointment();
          }}
        >
          {/* Pre-Register Now */}
          {locales.AppointmentBtn}
        </Link>
      );
    }
  };

  /**
   * 渲染视频模块
   * @returns {false|JSX.Element}
   */
  const renderVideoPart = () => {
    return (
      store.showVideoPart && (
        <div className="index-layer-13 " data-name="视频窗口">
          <div className={'video-open-status'} onClick={store.openVideoModal}>
            <div className={styles.videoOpenStatusItem1} />
            <div className={styles.videoOpenStatusItem2} />
          </div>
          <div className={cx(styles.videoCloseContainer, 'video-close-status')}>
            <div className={styles.videoCloseBorder} />
            <div className={styles.videoCloseBreath} />
            <div className={styles.videoCloseTips} />
          </div>
        </div>
      )
    );
  };

  return (
    <div className={cx(styles.firstScreenRoot, store.isActive && styles.firstScreenRootAct)}>
      <div className={styles.kv}>
        <SilentVideo className={styles.videoKv} cover={require('./images/kv.jpg')} src={''} />
        <div className={styles.hud} />
        <div className={styles.scroll} />
      </div>

      <div className={styles.firstScreenContainer}>
        {renderVideoPart()}
        <div className={styles.newsList}>
          <NewsSwiper store={store.newsSwiperStore} />
        </div>
        <div className={styles.slogan} />
        <div className={styles.contentText} />
      </div>
    </div>
  );
};

export default wrapStore(FirstSection, FirstSectionStore);
